import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import statelist from "../assets/Json/statedistrict.json";
import { Form } from "react-bootstrap";
// import { display } from "@mui/system";
function Header() {
  const navigate = useNavigate();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [authCategory, setAuthCategory] = useState(0);
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [StKey, setStKey] = useState("");

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Email or password not valid.");
    }
    let formData = { userName: email, password: password };
    await axios
      .post("https://image123.aicte-india.org/face/user/login", formData, {})
      .then((res) => {
        if (res.data.status === "success") {
          localStorage.setItem("user", JSON.stringify(res.data.data.user));
          localStorage.setItem("token", res.data.token);
          if (res.data.data.user.role === "admin") {
            navigate("/JaduiDarpan/VideoDetailPage");
          } else {
            navigate("/JaduiDarpan/validatorView");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlestselect = (key) => {
    setStKey(key);

    setState(statelist.states[key].state);
    console.log(state);
  };
  const handleDistrict = (key) => {
    console.log(key, state);
    setDistrict(key);
    localStorage.setItem("state", state);
    localStorage.setItem("district", key);
  };

  return (
    <div>
      <div className="popup-login-signup login">
        <div className="row">
          <div className="col-lg-12 p-0 login-left-box">
            <div className="login-box">
              <div>
                {authCategory === 0 ? (
                  <div className="LoginArea">
                    <h3>Sign In</h3>
                    <p>Use your email to continue with ANUVADINI!</p>

                    <div>
                      <div className="login-form text-start">
                        <div className="form-group mt-3">
                          <label for="email" className="label-text">
                            Email
                          </label>
                          <input
                            autoFocus="autofocus"
                            id="email"
                            type="email"
                            className="form-input form-control"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="name@example.com"
                          />
                        </div>
                        <div className="selectstate d-flex justify-content-start text-start">
                          <Form.Group className="mb-3 w-50">
                            <Form.Label htmlFor="StateSelect">
                              Select State
                            </Form.Label>
                            <Form.Select
                              id="StateSelect"
                              className="form-control"
                              onChange={(e) => handlestselect(e.target.value)}
                            >
                              <option>Select State</option>
                              {statelist.states.map((index, key) => (
                                <>
                                  <option value={key}>{index.state}</option>
                                </>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          {StKey ? (
                            <>
                              {" "}
                              <Form.Group className="mb-3 w-50 ml-3">
                                <Form.Label htmlFor="DistrictSelect">
                                  Select District
                                </Form.Label>
                                <Form.Select
                                  id="DistrictSelect"
                                  className="form-control"
                                  onClick={(e) =>
                                    handleDistrict(e.target.value)
                                  }
                                >
                                  <option>Select District</option>
                                  {statelist.states[StKey].districts.map(
                                    (index) => (
                                      <>
                                        <option value={index}>{index}</option>
                                      </>
                                    )
                                  )}
                                </Form.Select>
                              </Form.Group>
                            </>
                          ) : (
                            <>
                              {" "}
                              <Form.Group className="mb-3 w-50 ml-3">
                                <Form.Label htmlFor="DistrictSelect">
                                  Select District
                                </Form.Label>
                                <Form.Select
                                  id="DistrictSelect"
                                  className="form-control"
                                >
                                  <option>Select District</option>
                                </Form.Select>
                              </Form.Group>
                            </>
                          )}
                        </div>
                        <div className="form-group mt-3">
                          <label for="password" className="label-text">
                            Password
                          </label>
                          <input
                            data-testing-id="password"
                            id="password"
                            type="password"
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-input form-control"
                            placeholder="*********"
                          />
                        </div>
                        <div className="form-group mt-3">
                          <button
                            className="button orange"
                            onClick={(e) => handleLogin()}
                          >
                            Sign In
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="mt-1">
                      <Link
                        href="#!"
                        className="clickSignupArea"
                        onClick={() => setAuthCategory(1)}
                      >
                        New User?
                      </Link>
                      &nbsp;&nbsp;
                      <Link
                        to="#!"
                        className="clickResetPassArea"
                        onClick={() => setAuthCategory(2)}
                      >
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                ) : authCategory === 1 ? (
                  <div className="SignupArea">
                    <h3>Sign up</h3>
                    <p>Use your email to continue with ANUVADINI!</p>

                    <div>
                      <form className="login-form">
                        <div className="form-group mt-3">
                          <label for="email" className="label-text">
                            User Name
                          </label>
                          <input
                            autoFocus="autofocus"
                            id="email"
                            type="email"
                            className="form-input form-control"
                            placeholder="Enter Name"
                          />
                        </div>
                        <div className="form-group mt-3">
                          <label for="email" className="label-text">
                            Email Address
                          </label>
                          <input
                            autoFocus="autofocus"
                            id="email"
                            type="email"
                            className="form-input form-control"
                            placeholder="name@example.com"
                          />
                        </div>
                        {/* <div className="form-group mt-3">
                                                        <label for="email" className="label-text">State</label>
                                                        <input autoFocus="autofocus" id="email" type="email" className="form-input form-control" placeholder="name@example.com" />
                                                    </div>
                                                    <div className="form-group mt-3">
                                                        <label for="email" className="label-text">District</label>
                                                        <input autoFocus="autofocus" id="email" type="email" className="form-input form-control" placeholder="name@example.com" />
                                                    </div> */}
                        <div className="selectstate d-flex justify-content-start text-start">
                          <Form.Group className="mb-3 w-50">
                            <Form.Label htmlFor="StateSelect">
                              Select State
                            </Form.Label>
                            <Form.Select
                              id="StateSelect"
                              className="form-control"
                              onChange={(e) => handlestselect(e.target.value)}
                            >
                              <option>Select State</option>
                              {statelist.states.map((index, key) => (
                                <>
                                  <option value={key}>{index.state}</option>
                                </>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          {StKey ? (
                            <>
                              {" "}
                              <Form.Group className="mb-3 w-50 ml-3">
                                <Form.Label htmlFor="DistrictSelect">
                                  Select District
                                </Form.Label>
                                <Form.Select
                                  id="DistrictSelect"
                                  className="form-control"
                                  onClick={(e) =>
                                    handleDistrict(e.target.value)
                                  }
                                >
                                  <option>Select District</option>
                                  {statelist.states[StKey].districts.map(
                                    (index) => (
                                      <>
                                        <option value={index}>{index}</option>
                                      </>
                                    )
                                  )}
                                </Form.Select>
                              </Form.Group>
                            </>
                          ) : (
                            <>
                              {" "}
                              <Form.Group className="mb-3 w-50 ml-3">
                                <Form.Label htmlFor="DistrictSelect">
                                  Select District
                                </Form.Label>
                                <Form.Select
                                  id="DistrictSelect"
                                  className="form-control"
                                >
                                  <option>Select District</option>
                                </Form.Select>
                              </Form.Group>
                            </>
                          )}
                        </div>
                        <div className="form-group mt-3">
                          <label for="password" className="label-text">
                            Password
                          </label>
                          <input
                            data-testing-id="password"
                            id="password"
                            type="password"
                            className="form-input form-control"
                            placeholder="*******"
                          />
                        </div>
                        <div className="form-group mt-3">
                          <button className="button orange">Sign Up</button>
                        </div>
                      </form>
                    </div>
                    <div className="mt-1">
                      <Link
                        to="#!"
                        className="clickLoginArea"
                        onClick={() => setAuthCategory(0)}
                      >
                        Login?
                      </Link>
                      &nbsp;&nbsp;
                      <Link
                        to="#!"
                        className="clickResetPassArea"
                        onClick={() => setAuthCategory(2)}
                      >
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div className="ResetPassArea">
                    <h3>Forgot Password</h3>
                    <p>Use your email to continue with ANUVADINI!</p>
                    <div>
                      <form className="login-form">
                        <div className="form-group">
                          <label for="email" className="label-text">
                            Email Address
                          </label>
                          <input
                            autoFocus="autofocus"
                            id="email"
                            type="email"
                            className="form-input form-control"
                            placeholder="name@example.com"
                          />
                        </div>
                        <div className="form-group mt-3">
                          <button className="button orange">Submit</button>
                        </div>
                      </form>
                    </div>
                    <div className="mt-1">
                      <Link
                        to="#!"
                        className="clickSignupArea"
                        onClick={() => setAuthCategory(1)}
                      >
                        Sign Up?
                      </Link>
                      &nbsp;&nbsp;
                      <Link
                        to="#!"
                        className="clickLoginArea"
                        onClick={() => setAuthCategory(0)}
                      >
                        Login?
                      </Link>
                    </div>
                  </div>
                )}

                <div className="sml-txt">
                  <p>
                    {" "}
                    By continuing, you agree to our{" "}
                    <Link to="/JaduiDarpan/tirmOfUse" className="undeline">
                      Terms Of Use
                    </Link>{" "}
                    and{" "}
                    <Link to="/JaduiDarpan/privacyPolicy" className="undeline">
                      Privacy Policy
                    </Link>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
